import React, { useContext } from 'react';
import { APPLE_BUTTON_IMG } from '../../../config/constants/images';
import {
  APPLE_BUTTON_TEXT,
  APPLE_BUTTON_IMG_TEXT,
} from '../../../config/text/text';
import ThemeContext from '../../../providers/ThemeProvider';

const AppleButton = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <span className="sr-only">{APPLE_BUTTON_TEXT}</span>
      <img
        alt={APPLE_BUTTON_IMG_TEXT}
        className="apple"
        src={APPLE_BUTTON_IMG}
      />

      <style jsx>{`
        .apple {
          width: 85%;
          padding: 5%;
        }

        .sr-only {
          font-size: 22px;
          font-family: -apple-system;
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .apple {
            width: 90%;
            padding: 10px;
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .apple {
            width: 90%;
            padding: 15px;
          }
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .apple {
            width: 90%;
            padding: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default AppleButton;
